import {
  GETVIEWWALLETOWNERBANKDETAILS_SUCCESS,
  GETVIEWWALLETOWNERBANKDETAILS_FAILED,
  RESET_GETVIEWWALLETOWNERBANKDETAILS,
  LOADING_GETVIEWWALLETOWNERBANKDETAILS,
  NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetViewWalletOwnerBankDetails = () => {
  return { type: RESET_GETVIEWWALLETOWNERBANKDETAILS };
};

const getViewWalletOwnerBankDetailsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETVIEWWALLETOWNERBANKDETAILS });
    await partnerServices
      .post("getViewWalletOwnerBankDetails", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "success":
            dispatch(getViewWalletOwnerBankDetailssuccess(res.data));
            break;
          default:
            dispatch(getViewWalletOwnerBankDetailsFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_GETVIEWWALLETOWNERBANKDETAILS,
          payload: err,
        });
      });
  };
function getViewWalletOwnerBankDetailssuccess(data) {
  return {
    type: GETVIEWWALLETOWNERBANKDETAILS_SUCCESS,
    payload: data,
  };
}
function getViewWalletOwnerBankDetailsFailed(data) {
  return {
    type: GETVIEWWALLETOWNERBANKDETAILS_FAILED,
    payload: data,
  };
}

export {
  resetGetViewWalletOwnerBankDetails,
  getViewWalletOwnerBankDetailsList,
};
